export interface ContentCheckResult {
  passed: boolean;
  reason?: string;
}

export type ErrorType = 'network' | 'service-busy' | 'content-review' | 'need_clarify' | 'rejected';

export interface ErrorState {
  type: ErrorType;
  message: string;
  retryCount: number;
  countdown?: number;
}

// ==================== 多 Agent 协作相关类型 ====================

/** Agent 步骤索引：0 = 需求分析, 1 = PRD文档, 2 = 原型建议 */
export type AgentStep = 0 | 1 | 2;

/** 单个 Agent 的运行状态 */
export type AgentStatus = 'pending' | 'running' | 'done' | 'error';

/** 单个 Agent 的完整状态 */
export interface AgentState {
  content: string;
  status: AgentStatus;
  error: ErrorState | null;
}

/** 步骤标签（用于步骤导航按钮文字） */
export const STEP_LABELS: readonly string[] = ['需求分析', 'PRD文档', '原型建议'];

/** PRD 模块导航标题（Agent 2 的 PRD 文档章节锚点） */
export const NAV_TITLES: readonly string[] = [
  '需求背景',
  '用户故事',
  '核心功能描述',
  '验收标准',
  '交互与异常处理',
];
